import { Banner, Box } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { getRequest } from '../../shared/components/functions.jsx';

// Reminds users who pasted a signature with an embedded banner that their business unit has a new banner since
export default function SignatureBannerNotice() {
  const [copyStatus, setCopyStatus] = useState(null);

  useEffect(() => {
    let isMounted = true;
    getRequest('/api/business_units/signature-copies/me').then((result) => {
      if (isMounted && result && typeof result === 'object') setCopyStatus(result);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!copyStatus?.outdated) return null;

  return (
    <Box paddingBlockEnd="400">
      <Banner tone="warning" title="Your email signature banner has changed" action={{ content: 'Update my signature', url: '/account' }}>
        <p>{`${copyStatus.businessUnitName || 'Your business unit'} has a new email banner. Copy your signature again on your account page and replace it in your mail app.`}</p>
      </Banner>
    </Box>
  );
}
